export default __webpack_public_path__ + "static/media/mbwhite.42e6ff46.png";